import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import * as BasAgentActions from '../../../actions/basAgentActions';

import defaultClasses from '../../../components/BobTableContextMenu.module.css';

const BasAgentContextMenu = ({
    agent,
    factoryResetAgent,
    history,
    pingBasAgent,
    rebootAgent,
    restartAgentApplication,
    setBasAgent,
    setFactoryResetAgentModalOpen,
    setSelectedAgent,
    setAssignAgentModalOpen,
    setDeleteAgentModalOpen,
    setRenameAgentModalOpen,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRenameAgent = () => {
        setRenameAgentModalOpen(true);
        setBasAgent(agent);
    };

    const handleAssignAgent = () => {
        setAssignAgentModalOpen(true);
        setBasAgent(agent);
    };

    const handlePingAgent = () => {
        pingBasAgent(agent.id);
    };

    const handleRebootAgent = () => {
        rebootAgent(agent.id);
    };

    const handleRestartApplication = () => {
        restartAgentApplication(agent.id);
    };

    const handleDeleteAgent = () => {
        setDeleteAgentModalOpen(true);
        setBasAgent(agent);
    };

    const handleManageAgent = () => {
        setSelectedAgent(agent);
        const path = '/v2/dashboard/iothub/manage';
        const queryValues = queryString.parse(history.location.search);
        queryValues.agent = agent.id;

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={handleManageAgent}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-cog" />
                    Manage Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handleRenameAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-edit" />
                    Rename Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handlePingAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="far fa-bell" />
                    Ping Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handleRebootAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-power-off" />
                    Reboot Agent
                </MenuItem>
                {/* <MenuItem
                    onClick={() => handleFactoryReset()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-undo" />
                    Factory Reset
                </MenuItem> */}
                <MenuItem
                    onClick={() => handleAssignAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-link" />
                    Assign Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteAgent()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-trash" />
                    Delete Agent
                </MenuItem>
                <MenuItem
                    onClick={() => handleRestartApplication()}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <i className="fas fa-history" />
                    Restart Application
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

const mapDispatchToProps = {
    ...BasAgentActions
};

export default withRouter(connect(null, mapDispatchToProps)(BasAgentContextMenu));
